import React from "react";

interface FormattedTextProps extends React.HTMLAttributes<HTMLDivElement> {
  children: string | string[] | null | undefined;
}

export const FormattedText: React.FC<FormattedTextProps> = ({
  children,
  style,
  ...props
}) => {
  if (!children) return null;

  // Step 1: Extract and normalize the text
  let text: string;

  if (Array.isArray(children)) {
    text = children.join("\n\n");
  } else if (typeof children === "string") {
    try {
      const parsed = JSON.parse(children);
      text = Array.isArray(parsed) ? parsed.join("\n\n") : children;
    } catch {
      text = children;
    }
  } else {
    return null;
  }

  // Step 2: Convert escaped `\n` to real newlines
  text = text.replace(/\\n/g, "\n").trim();

  // Step 3: Split into paragraphs
  const paragraphs = text.split(/\n\s*\n/);

  return (
    <div style={style} {...props}>
      {paragraphs.map((paragraph, pIndex) => (
        <p
          key={pIndex}
          style={{ marginBottom: pIndex < paragraphs.length - 1 ? "1em" : 0 }}
        >
          {paragraph.split(/\n/).map((line, lIndex, lines) => (
            <React.Fragment key={lIndex}>
              {line}
              {lIndex < lines.length - 1 ? <br /> : null}
            </React.Fragment>
          ))}
        </p>
      ))}
    </div>
  );
};
